import { useEffect, useState } from 'react';
import { Alert, Box, Button } from '@mui/material';
import { Navigate } from 'react-router-dom';
import LoadingScreen from '../components/shared/LoadingScreen';
import useAuth from '../hooks/useAuth';
import { BillingInfo } from '../interfaces/account';
import { getBillingInfo } from '../services/settingsServices';

export default function AccountHomeRedirect() {
  const { user } = useAuth();
  const [result, setResult] = useState<{
    user: typeof user;
    destination?: string;
    error?: boolean;
  } | null>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setResult(null);

    const loadDestination = async () => {
      try {
        const response = await getBillingInfo();
        const billingInfo: BillingInfo | null = response.data;

        if (active) {
          setResult({
            user,
            destination: billingInfo?.subscription_data?.is_agentic_billing_account === true
              ? '/agentic'
              : '/home',
          });
        }
      } catch {
        if (active) {
          setResult({ user, error: true });
        }
      }
    };

    void loadDestination();

    return () => {
      active = false;
    };
  }, [user, attempt]);

  if (!result || result.user !== user) {
    return <LoadingScreen />;
  }

  if (result.error || !result.destination) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert
          severity="error"
          action={
            <Button color="inherit" onClick={() => {
              setResult(null);
              setAttempt((value) => value + 1);
            }}>
              Retry
            </Button>
          }
        >
          Unable to load your account billing information. Please try again.
        </Alert>
      </Box>
    );
  }

  return <Navigate to={result.destination} replace />;
}
